import React from 'react';
import { HStack, Button, Text, Box, Icon, Spacer } from '@chakra-ui/react';
import { ArrowForwardIcon } from '@chakra-ui/icons';

const getPageNumbers = (current, total) => {
  let arr;
  if (total <= 20) arr = Array.from({ length: total }, (_, i) => i + 1);
  else if (current <= 3) arr = [1, 2, 3, 4, '...', total];
  else if (current >= total - 2) arr = [1, '...', total - 3, total - 2, total - 1, total];
  else arr = [1, '...', current - 1, current, current + 1, '...', total];
  // Remove consecutive duplicates and duplicate numbers
  return arr.filter((v, i, a) => v !== a[i - 1]);
};

const JobOpeningPagination = ({ currentPage, totalPages, totalJobs, jobsPerPage, onPageChange }) => {
  // Don't render pagination if there's only one page or no jobs
  if (totalPages <= 1 || totalJobs === 0) {
    return null;
  }

  const start = (currentPage - 1) * jobsPerPage + 1;
  const end = Math.min(currentPage * jobsPerPage, totalJobs);
  const pageNumbers = getPageNumbers(currentPage, totalPages);

  return (
    <HStack mt={8} px={2} py={4} borderTop="1px solid #eee" spacing={4} justify="space-between">
      <HStack spacing={1}>
        {pageNumbers.map((num, idx) =>
          num === '...'
            ? <Text key={idx} px={2}>...</Text>
            : <Button
                key={num}
                size="sm"
                colorScheme={num === currentPage ? 'green' : 'gray'}
                variant={num === currentPage ? 'solid' : 'ghost'}
                borderRadius="full"
                onClick={() => onPageChange(num)}
                minW={8}
              >
                {num}
              </Button>
        )}
        {currentPage < totalPages && (
          <Button size="sm" variant="ghost" borderRadius="full" onClick={() => onPageChange(totalPages)}>
            Last <Icon as={ArrowForwardIcon} ml={1} />
          </Button>
        )}
      </HStack>
      <Spacer />
      <Text fontSize="sm" color="gray.600">
        Showing <b>{start}</b> to <b>{end}</b> of <b>{totalJobs.toLocaleString()}</b>
      </Text>
    </HStack>
  );
};

export default JobOpeningPagination; 